var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinnerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_0_4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6 1V3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.1 3.9L9.55 2.45",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9 6H11",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.1 8.1L9.55 9.55",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M6 9V11",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M2.45 9.55L3.9 8.1",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M1 6H3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M2.45 2.45L3.9 3.9",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnerIcon);
export default __webpack_public_path__ + "static/media/spinner-icon.1edec5bf78ad3f174b2b3b3b122358f4.svg";
export { ForwardRef as ReactComponent };